
import { useState } from "react";
import MainLayout from "../layout/MainLayout";
import SewaArrears from "../components/arreasCollection/Sewa/SewaArrears";
import AirArrears from "../components/arreasCollection/Air/AirArrears";


const RentArrearsReport = () => {

  const [type, setType] = useState('')

  return (
    <MainLayout>
    <div className="p-5">
      <label className="mb-3">Chose Client Type </label>
      <select className="mb-2 border w-full py-2 px-3 rounded-lg" onChange={(e) => setType(e.target.value)}>
        <option value=''>--Chose Client Type--</option>
        <option value='sewa' >Sewa</option>
        <option value='air'>Air</option>
      </select>

         {type === "sewa" && <SewaArrears/>}
         {type === "air" && <AirArrears/>}

    </div>
    </MainLayout>
  );
}
export default RentArrearsReport